import { AddToBlacklistDto, AddToBlacklistDtoImpl } from '../addtoblacklist/addtoblacklistdto';

export interface RemoveFromBlacklistDto extends AddToBlacklistDto
{
    
}

export class RemoveFromBlacklistDtoImpl extends AddToBlacklistDtoImpl implements RemoveFromBlacklistDto
{
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/removefromblacklist/removefromblacklistdto.ts